export default "__VITE_ASSET__BBo0eibC__"